import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter30 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);
    return (
        <>
                 {/* Chapter 30 */}
                <section id="section30" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter30Title}</h2>

                    <ul className="drivers-handbook-list">
                        <li>{language.chapter30List1Title}</li>

                        <ul className="drivers-handbook-list">
                            <li>{language.chapter30List1}</li>
                        </ul>

                        <li>{language.chapter30List2Title}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter30List2}</li>
                        </ul>


                        <li>{language.chapter30List3Title}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter30List31}.</li>
                            <li>{language.chapter30List32}</li>
                            <li>{language.chapter30List33}</li>
                            <li>{language.chapter30List34}</li>
                        </ul>


                        <li>{language.chapter30List4Title}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter30List4}</li>
                        </ul>


                        <li>{language.chapter30List5Title}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter30List5}</li>
                        </ul>

                        <li>{language.chapter30List6Title}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter30List6}
                            </li>
                        </ul>

                        <li>{language.chapter30List7Title}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter30List7}
                            </li>
                        </ul>
                    </ul>
                </section>
        </>
    )

}

export default Chapter30;
